
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/menu",
      function () {
        return require("private-next-pages/menu/index.tsx");
      }
    ]);
  